export default __webpack_public_path__ + "static/image10-a672cdfe4f38557611fbfec506a6998b.gif";